import { render, staticRenderFns } from "./sider-trigger.vue?vue&type=template&id=219943da"
import script from "./sider-trigger.vue?vue&type=script&lang=ts"
export * from "./sider-trigger.vue?vue&type=script&lang=ts"
import style0 from "./sider-trigger.vue?vue&type=style&index=0&id=219943da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports